// extracted by mini-css-extract-plugin
module.exports = {"cards_container":"Card_cards_container__22qWd","cards_header":"Card_cards_header__3QA05","user_icon":"Card_user_icon__GnAO_"};